import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="documents"
export default class extends Controller {
  static values = {
    filename: String,
    documentType: String
  }

  declare filenameValue: string
  declare documentTypeValue: string

  trackDownload (): void {
    const documentType = this.getDocumentType()

    window.segment?.track('[ER] Document Downloaded', {
      filename: this.filenameValue,
      document_type: documentType,
      page: 'employer_documents'
    })
  }

  private getDocumentType (): string {
    if (this.documentTypeValue) {
      return this.documentTypeValue
    }

    const filename = this.filenameValue.toLowerCase()

    if (filename.includes('1095-b')) {
      return '1095-b'
    }

    if (filename.includes('1095-c')) {
      return '1095-c'
    }

    return 'other'
  }
}
